import React, { Component } from 'react';
import './hazard.css';

class Hazard extends Component {
    render() {
        const { label, IconComponent } = this.props.data;

        return (
            <div onClick={this.props.onClick} className="hazard-wrap">
                <div className="hazard">
                    {<IconComponent />}
                    <p>{label}</p>
                </div>
            </div>
        );
    }
}

export default Hazard;



// WEBPACK FOOTER //
// ./src/components/hazard/hazard.js